// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IuyO","input":"styles_input__sa4MA"};